import {
	Instance,
	SnapshotIn,
	applySnapshot,
	flow,
	getParent,
	getSnapshot,
	types,
} from 'mobx-state-tree';

import { deleteDocumentsItem, getDocumentsItem, updateDocumentsItem } from '@common/api/documents';
import { IDocumentsModel } from '@common/models/Documents/Documents';
import Group from '@common/models/Groups/Group';
import Location from '@common/models/Locations/Location';
import Media from '@common/models/Media';

const DocumentsItem = types
	.model('DocumentsItem', {
		id: types.identifierNumber,
		title: types.optional(types.string, ''),
		locations_ids: types.optional(types.array(Location), []),
		groups_ids: types.optional(types.array(Group), []),
		file_url: types.maybeNull(types.string),
		file: types.maybeNull(Media),
	})
	.volatile(() => ({
		loading: false,
	}))
	.views(() => ({}))
	.actions((self) => ({
		fetch: flow(function* () {
			self.loading = true;

			try {
				const result = yield getDocumentsItem(self.id);
				applySnapshot(self, result);
			} finally {
				self.loading = false;
			}
		}),
		remove: flow(function* () {
			self.loading = true;

			try {
				yield deleteDocumentsItem(self.id);
				const parent = getParent<IDocumentsModel>(self, 2);
				parent.removeItem(self as IDocumentsItemModel);
			} catch (e) {
				self.loading = false;
			}
		}),
		save: flow(function* (data: any, isGetSnapshot: boolean = true) {
			self.loading = true;
			try {
				const result = yield updateDocumentsItem(
					self.id,
					isGetSnapshot
						? {
							...getSnapshot(self),
							...data,
						}
						: data,
				);
				applySnapshot(self, result);
			} catch (e) {
				self.loading = false;
			} finally {
				self.loading = false;
			}
		}),
	}));

export default DocumentsItem;

export interface IDocumentsItemModel extends Instance<typeof DocumentsItem> { }
export type IDocumentsItemSnapshotIn = SnapshotIn<typeof DocumentsItem>;
